import React from 'react'

const Pinterest = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="27"
        height="26"
        viewBox="0 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M25.6282 10.8033C24.6604 2.14605 13.7453 -2.53965 6.27197 2.43185C3.23034 4.45321 1.19285 7.80324 0.588876 11.3604C0.174099 13.8176 0.443335 16.4391 1.54944 18.7034C2.65546 20.9605 4.50378 22.7962 6.90505 23.6677C14.3638 26.389 24.5002 23.4533 25.6282 14.8818C25.8102 13.532 25.781 12.1533 25.6282 10.8033Z"
            fill="#666059"
            stroke="#666059"
            strokeWidth="0.808249"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.26845 14.0053C6.65356 11.8482 7.90708 7.51155 12.0443 6.67137C16.6586 5.73288 19.0886 8.98732 18.4733 12.4916C18.035 14.9891 15.7203 16.7602 13.4594 16.5407C11.3061 16.3288 10.1756 13.9598 10.6294 11.8104C10.7448 11.2503 11.0447 10.2664 11.606 10.0545C12.2827 9.79719 12.006 11.3336 11.8059 12.1888C11.3754 14.0507 10.1449 18.6448 8.84521 19.8178"
            stroke="white"
            strokeWidth="1.6165"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default Pinterest
